import React from "react";
import { useSelector } from "react-redux";
import { ReactComponent as InteractiveDiagramIcon } from "../../../assets/icons/AssetManager/interactive-diagram-icon.svg";
import { ReactComponent as AddHotspotIcon } from "../../../assets/icons/AssetManager/hotspot-icon-toolbar-white.svg";
import { ADD_NEW_VISIBLE_HOTSPOT, useInteractivityBuilderState } from "../../../contexts/InteractivityBuilderProvider";
import AddTableButton from "../../Tables/AddTableButton";
import EditTableMenu from "../../Tables/EditTableMenu";
import { useTablesDataDispatch } from "../../Tables/TablesDataProvider";
import { useSelectedObjectDispatch } from "../../../contexts/SelectedObjectProvider/SelectedObjectProvider";
import { useInteracitvityHotspotDispatch } from "../../../contexts/InteractivityHotspotProvider";
import { ObjectActionsType, useObjectsDispatch, useObjectsState } from "../../../contexts/ObjectsProvider";
import { AbstractTooltip as Tooltip } from "../../ToolTip/ToolTip";
import { DEFAULT_HOTSPOT } from "../../../const";
import { nanoid } from "../../../lib/nanoId";
type MajorsType = {
  isFreeForm?: boolean;
  isVideoButtonShown?: boolean;
  isSCORMButtonShown?: boolean;
  areMajorsDisabled?: boolean;
  addNewImageBox?: () => void;
  addNewTextBox?: () => void;
  addNewVideo?: () => void;
  addNewSCORM?: () => void;
  addNewTable?: () => void;
  permissions?: { [key: string]: boolean };
  setOldPropertyBoxIsShown?: (value: boolean) => void;
};
const HOTSPOT_LIMIT = 150;
const MajorElements = (props: MajorsType) => {
  const tablesDispatch = useTablesDataDispatch();
  const selectedObjectDispatch = useSelectedObjectDispatch();
  const interactivityBuilderState = useInteractivityBuilderState();
  const interactivityHotspotDispatch = useInteracitvityHotspotDispatch();
  const { hotspots } = useObjectsState();
  const objectDispatch = useObjectsDispatch();
  const { images, annotations, selectedObjects, moveableRef, textBoxes, videos, objectList } = useObjectsState();

  // interactivityBuilderState?.interactivityBuilderInstance?.getAllHotspots().length; -- fix

  const scormObject = objectList.find((x: any) => x.type === "SCORM");
  const hasSCORMorVIDEO = scormObject || videos[0] ? true : false;
  if (props.isFreeForm && props.areMajorsDisabled) {
    return (
      <React.Fragment>
        <button
          id="wysiwyg-text-button"
          className="wysiwyg-toolbar-btn"
          onClick={props.addNewTextBox}
          data-tooltip-id="AddTextBox"
        >
          <Tooltip id="AddTextBox" />
          <span className="icon-insert-text-box-icon-vector"></span>
        </button>
        <button
          id="wysiwyg-image-button"
          className="wysiwyg-toolbar-btn"
          onClick={props.addNewImageBox}
          data-tooltip-id="AddImage"
        >
          <Tooltip id="AddImage" />
          <span className="icon-image-icon"></span>
        </button>

        <button
          id="wysiwyg-video-button"
          className="wysiwyg-toolbar-btn"
          style={!hasSCORMorVIDEO ? {} : { backgroundColor: "var(--disabled-color)" }}
          onClick={() => {
            if (props.addNewVideo && !hasSCORMorVIDEO) props.addNewVideo();
          }}
          data-tooltip-id="AddVideo"
        >
          <Tooltip id="AddVideo" />
          <span className="icon-Video-icon"></span>
        </button>

        <button
          id="wysiwyg-video-button"
          className="wysiwyg-toolbar-btn"
          style={!hasSCORMorVIDEO ? {} : { backgroundColor: "var(--disabled-color)" }}
          onClick={() => {
            if (props.addNewSCORM && !hasSCORMorVIDEO) {
              props.addNewSCORM();
            }
          }}
          data-tooltip-id="AddInteractiveDiagram"
        >
          <Tooltip id="AddInteractiveDiagram" />
          <InteractiveDiagramIcon />
        </button>
        {props.permissions?.interactivity && (
          <button
            id="wysiwyg-hotspot-button"
            className="wysiwyg-toolbar-btn add-hotspot-button"
            style={(hotspots?.length ?? 0) < HOTSPOT_LIMIT ? {} : { backgroundColor: "var(--disabled-color)" }}
            // style={props.isSCORMButtonShown ? {} : { backgroundColor: 'var(--disabled-color)' }}
            onClick={() => {
              tablesDispatch({
                action: "setSelectedTable",
                payload: [undefined],
              });
              selectedObjectDispatch({ type: "SET_OBJECT_ID", payload: null });

              objectDispatch({
                type: ObjectActionsType.ADD_NEW_OBJECT,
                object: {
                  ...DEFAULT_HOTSPOT,
                  left: hotspots.length * 3 + 2,
                  top: hotspots.length * 3 + 2,
                  objectId: nanoid(),
                  displayName: "Hotspot " + (hotspots.length + 1),
                },
              });
            }}
            data-tooltip-id="AddHotSpot"
          >
            <Tooltip id="AddHotSpot" />
            <AddHotspotIcon />
          </button>
        )}
        {props.permissions?.tables ? <AddTableButton /> : null}

        <hr className="wysiwyg-toolbar-divider" />
      </React.Fragment>
    );
  }
  return <></>;
};

export default MajorElements;
